// removed by extract-text-webpack-plugin
module.exports = {"usm-container":"DisplayExample__usm-container","usmContainer":"DisplayExample__usm-container","usm-image":"DisplayExample__usm-image","usmImage":"DisplayExample__usm-image","usm-label":"DisplayExample__usm-label","usmLabel":"DisplayExample__usm-label"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Select/components/DisplayExample/DisplayExample.css
// module id = 1247
// module chunks = 8